import { SET_PARTNERS, REMOVE_PARTNER } from './PartnerActions.js';
import { LOGOUT_USER } from '../User/UserActions.js';

export const initialState = {
    data: [],
};

const PartnerReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_PARTNERS: {
            const others = state.data.filter(p => !action.partners.find(toSet => toSet._id === p._id));
            return { ...state, data: others.concat(action.partners) };
        }

        case REMOVE_PARTNER:
            return { ...state, data: state.data.filter(p => p._id !== action.partnerId) };

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default PartnerReducer;
